// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ordini-filter-row-grid {
  display: grid;
  width: 100%;
}

.ordini-filter-row-desktop {
  flex-wrap: nowrap;
  min-width: 0;
  width: 100%;
}

.ordini-filter-row-desktop > .ordini-filter-row-cell,
.ordini-filter-row-grid > ion-col {
  min-width: 0;
  max-width: none;
  overflow: hidden;
}

.ordini-filter-row-desktop > .ordini-filter-row-cell > *,
.ordini-filter-row-desktop app-select-risorsa,
.ordini-filter-row-desktop app-select-lavorazione,
.ordini-filter-row-desktop app-ordini-filter-row-codice-univoco,
.ordini-filter-row-desktop ion-input,
.ordini-filter-row-desktop ion-select {
  min-width: 0;
  max-width: 100%;
}

.ordini-filter-row-desktop ion-input::part(native),
.ordini-filter-row-desktop ion-select::part(text) {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/ordini-filter-row/ordini-filter-row.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;;EAEE,YAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;;;;;;EAME,YAAA;EACA,eAAA;AACF;;AAEA;;EAEE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".ordini-filter-row-grid {\n  display: grid;\n  width: 100%;\n}\n\n.ordini-filter-row-desktop {\n  flex-wrap: nowrap;\n  min-width: 0;\n  width: 100%;\n}\n\n.ordini-filter-row-desktop > .ordini-filter-row-cell,\n.ordini-filter-row-grid > ion-col {\n  min-width: 0;\n  max-width: none;\n  overflow: hidden;\n}\n\n.ordini-filter-row-desktop > .ordini-filter-row-cell > *,\n.ordini-filter-row-desktop app-select-risorsa,\n.ordini-filter-row-desktop app-select-lavorazione,\n.ordini-filter-row-desktop app-ordini-filter-row-codice-univoco,\n.ordini-filter-row-desktop ion-input,\n.ordini-filter-row-desktop ion-select {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.ordini-filter-row-desktop ion-input::part(native),\n.ordini-filter-row-desktop ion-select::part(text) {\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
